<template>
    <sui-scroll class="igc-subtab"
        horizontal
        :style="{ 'background': mBackground(17, 'top', 16) }">
        <div class="ig--item"
            v-for="item in tab.label"
            :key="item.id"
            @click="$emit('switch-tab', item)">
            <sui-image class="ig--image"
                :src="imageGetter(item)"></sui-image>
            <div :style="{ 'color': item.id == active ? mColor(14) : mColor(15.1) }">{{ item.name }}</div>
        </div>
        <div class="ig--all"
            v-if="more"
            @click="$router.push({ name: 'label', params: { category: tab.category, subcategory: 0 } })">
            <div class="ig--icon"
                :style="{ 'background-image': `url(${ imagePath }/all.png)` }"></div>
            <div class="ig--placeholder">占位</div>
        </div>
    </sui-scroll>
</template>

<script>
import mCore from '../../scripts/mixins/core'

export default {
    name: 'igc-subtab',

    mixins: [mCore],

    props: {
        tab: {
            type: Object,
            required: true
        },

        active: {
            type: [String, Number],
            required: true
        }
    },

    watch: {
        'active': function (nv) {
            this.mEventTracking('tab_2', '选项卡_二级', {
                id: nv
            })
        }
    },
    
    methods: {
        imageGetter(item) {
            if(item.icon && item.icon.replace(/\s/g,'')){
                return item.icon
            }
            return `${ this.imagePath }/label/${ item.id }.png`
        }
    },

    computed: {
        imagePath() {
            return this.$store.getters['global/imagePath']
        },

        category() {
            let category = this.$store.state.global.knowledge[this.tab.category]
            return this.tab.category && category ? category.category : []
        },

        /**
         * 是否展示查看全部：如果导航上未展示所有知识点，则显示查看全部
         */
        more() {

            // #region 子导航非知识点，无查看全部
            if (!this.tab.category) {
                return false
            }
            // #endregion

            let more = false
            let labelMap = {}
            this.tab.label.forEach(item => {
                labelMap[item.id] = item
            })
            for (let i = 0; i < this.category.length; i++) {
                const { kn = [] } = this.category[i]
                let every = kn.every((item) => {
                    return Boolean(labelMap[item.v4_id])
                })
                if (!every) {
                    more = true
                    break
                }
            }
            return this.tab.category && more
        }
    },
}
</script>

<style lang="postcss">
.igc-subtab {
    flex: none;
    display: flex;
    width: 100%;
    height: 145px;
    font-size: 20px;
    .ig--item {
        flex: none;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-left: 36px;
        .ig--image {
            width: 72px;
            height: 72px;
            margin-bottom: 6px;
        }
    }
    .ig--all {
        flex: none;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 36px;
        .ig--icon {
            width: 72px;
            height: 72px;
            margin-bottom: 6px;
            background: no-repeat center / contain;
        }
        .ig--placeholder {
            visibility: hidden;
        }
    }
}
</style>
